import { ReactNode } from 'react';
import { AnalyticsQueueProvider } from '@bridebook/web/lib/wedding-website/analytics/analytics-queue-context';
import { HideFooterProvider } from '@bridebook/web/lib/ui/hooks/use-hide-footer';
import { PopupRoundedModalProvider } from '../lib/ui/modal/popup-rounded-modal-context';
import { GuestsMessagesProvider } from '@bridebook/web/components/inbox/guests/guests-messages-container';
import { ImperativeModalProvider, ImperativeDrawerOrModalProvider } from '@bridebook/aura';
import { RsvpModalProvider } from '@bridebook/web/components/wedding-website/rsvp/rsvp-modal.context';

type IProps = {
  children: ReactNode;
};

export const Providers = ({ children }: IProps) => (
  <HideFooterProvider>
    <ImperativeModalProvider>
      <ImperativeDrawerOrModalProvider>
        <AnalyticsQueueProvider>
          <PopupRoundedModalProvider>
            <GuestsMessagesProvider>
              <RsvpModalProvider>{children}</RsvpModalProvider>
            </GuestsMessagesProvider>
          </PopupRoundedModalProvider>
        </AnalyticsQueueProvider>
      </ImperativeDrawerOrModalProvider>
    </ImperativeModalProvider>
  </HideFooterProvider>
);

export default Providers;
